import { createSlice } from '@reduxjs/toolkit'

interface SceneState {
  nightMode: boolean
  shadingMode: boolean
  alignment: boolean
}

const initialState: SceneState = {
  nightMode: false,
  shadingMode: true,
  alignment: true,
}

export const sceneSlice = createSlice({
  name: 'scene',
  initialState,
  reducers: {
    setNightMode: (state, { payload }) => {
      state.nightMode = payload
    },
    setShadingMode: (state, { payload }) => {
      state.shadingMode = payload
    },
    setAlignmentMode: (state, { payload }) => {
      state.alignment = payload
    },
  },
})

// Component
export const { setNightMode, setShadingMode, setAlignmentMode } =
  sceneSlice.actions

// Store
export const sceneReducer = sceneSlice.reducer
